import React from 'react';

import ChevronLeftIcon from 'src/components/svgIcons/ChevronLeftIcon';
import ChevronRightIcon from 'src/components/svgIcons/ChevronRightIcon';

import { chevStyle } from './styles';

interface ArrowProps {
  disabled: boolean;
  left?: boolean;
  onClick: () => void;
  isSearchLanding?: boolean;
}

const Arrow: React.FC<ArrowProps> = ({
  disabled,
  left,
  onClick,
  isSearchLanding
}) => {
  return (
    <>
      {left && !disabled ? (
        <ChevronLeftIcon
          onClick={onClick}
          className={chevStyle(left ? 'left' : 'right', isSearchLanding)}
        />
      ) : (
        !disabled && (
          <ChevronRightIcon
            onClick={onClick}
            className={chevStyle(left ? 'left' : 'right', isSearchLanding)}
          />
        )
      )}
    </>
  );
};

export default Arrow;
